import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SuperAdminProvider } from '../context/SuperAdminContext';
import AllBusinessesView from '../components/AllBusinessesView';
import AllOfferingsView from '../components/AllOfferingsView';
import AllRedemptionsView from '../components/AllRedemptionsView';
import AllHotDealsView from '../components/AllHotDealsView';
import './Dashboard.css';

type TabType = 'businesses' | 'offerings' | 'hot-deals' | 'redemptions';

const SuperAdminDashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>('businesses');

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <SuperAdminProvider>
      <div className="dashboard-container">
        <header className="dashboard-header super-admin">
          <div className="header-content">
            <div className="header-brand">
              <img src="/logo.png" alt="LinkPerks" className="header-logo" />
            </div>
            <div className="header-actions">
              <div className="user-info">
                <span className="user-email">{user?.email}</span>
                <span className="user-role super">Super Admin</span>
              </div>
              <button onClick={handleLogout} className="logout-button">
                Logout
              </button>
            </div>
          </div>
        </header>

        <nav className="dashboard-nav">
          <div className="nav-content">
            <button
              className={`nav-tab ${activeTab === 'businesses' ? 'active' : ''}`}
              onClick={() => setActiveTab('businesses')}
            >
              🏢 Businesses
            </button>
            <button
              className={`nav-tab ${activeTab === 'offerings' ? 'active' : ''}`}
              onClick={() => setActiveTab('offerings')}
            >
              🎁 Offerings
            </button>
            <button
              className={`nav-tab ${activeTab === 'hot-deals' ? 'active' : ''}`}
              onClick={() => setActiveTab('hot-deals')}
            >
              🔥 Hot Deals
            </button>
            <button
              className={`nav-tab ${activeTab === 'redemptions' ? 'active' : ''}`}
              onClick={() => setActiveTab('redemptions')}
            >
              ✅ Redemptions
            </button>
          </div>
        </nav>

        <main className="dashboard-main">
          <div className="dashboard-content">
            {activeTab === 'businesses' && <AllBusinessesView />}
            {activeTab === 'offerings' && <AllOfferingsView />}
            {activeTab === 'hot-deals' && <AllHotDealsView />}
            {activeTab === 'redemptions' && <AllRedemptionsView />}
          </div>
        </main>
      </div>
    </SuperAdminProvider>
  );
};

export default SuperAdminDashboard;
